function merchantFraudCheckController(merchantService, messageService, fraudCheckData) {
    const vm = this;
    const init = function() {
        vm.form = {};
        vm.form.id = fraudCheckData.merchantId;
        vm.form.gateKeeperName = fraudCheckData.client;
        if (fraudCheckData.passwordExists) {
            vm.gateKeeperPasswordPlaceholder = '********';
        }
        vm.form.enableFraudChecking = fraudCheckData.enableFraudChecking;
        vm.form.upfrontCardValidationOverride = fraudCheckData.upfrontCardValidationOverride;
        vm.form.autoBillingOverride = fraudCheckData.autoBillingOverride;
    };
    vm.saveFraudCheckSettings = (isFormInvalid) => {
        if (isFormInvalid) {
            return;
        }
        if (!vm.form.upfrontCardValidationOverride) {
            vm.form.autoBillingOverride = false;
        }
        merchantService.updateFraudSettings(vm.form)
            .then(() => messageService.saveAlert('Changes saved'))
            .catch(reason =>  messageService.error(reason.data))
    };
    init();
}
angular
    .module('qkr.fraud.check')
    .controller('MerchantFraudCheckController', merchantFraudCheckController);



// WEBPACK FOOTER //
// ./src/fraud-check/merchant.fraud.check.controller.js